<script>
import AseetModifyForm from '@/components/asset/AseetModifyForm.vue';
export default {
components: {
    AseetModifyForm
    },
}
</script>

<template>
    <AseetModifyForm/>
</template>